module.exports = __webpack_public_path__ + "staticcomp/img/share.9c5dd32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/share.jpg
// module id = qSN3
// module chunks = 39